// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 350px;
  font-family: "Roboto", Arial, sans-serif;
  z-index: 999;
}

/* hide chat icon when open */
.chatbot-container.chat-open .chat-icon {
  display: none;
}

.chatbot {
  border: 1px solid #ddd;
  border-radius: 12px;
  background-color: #111827;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow: hidden;
  z-index: 2; /* added */
}

.chatbot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2596be;
  color: white;
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.close-button {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
}

.chatbot-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #111827 !important;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 999;
}

.message {
  display: inline-block;
  margin: 5px 0;
  padding: 10px 15px;
  border-radius: 16px;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
  max-width: 80%;
  word-wrap: break-word;
}

.message-meta {
  font-size: 11px;
  opacity: 0.7;
  margin-bottom: 4px;
}

.message.bot {
  background: linear-gradient(135deg, #0F0F3E 35%, #1A1A01 100%);
  color: #8d9b9e !important;
  align-self: flex-start;
  text-align: left;
}

.message.user {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
  color: white;
  align-self: flex-end;
  text-align: right;
}

.chatbot-footer {
  display: flex;
  gap: 8px;
  padding: 10px;
  background-color: #111827 !important;
  border-top: 1px solid #2bb8dd !important;
}

.chatbot-footer input,
.chatbot-footer textarea {
  flex: 1 1;
  padding: 12px;
  border-radius: 16px;
  border: 1px solid #ddd;
  font-size: 14px;
  font-family: "Roboto", Arial, sans-serif;
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
  color: #fff !important;
  resize: none;
}

.chatbot-footer button {
  background-color: #2596be;
  color: white;
  border: none;
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.chatbot-footer button:hover {
  background-color: #1b7892;
}

.chatbot-recommendations {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 0;
  align-items: center;
  animation: fadeIn 0.4s ease;
}

.recommendation-button {
  background-color: #2596be;
  color: white;
  border: none;
  border-radius: 32px;
  width: 80%;
  align-items: center;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.chat-fab-container.hidden {
  opacity: 0;
  pointer-events: none;
  transform: scale(0.9);
}

.chatbot-container {
  z-index: 100000;
}


.recommendation-button:hover {
  background-color: #1b7892;
}


/* .chat-icon {
  position: absolute; 
  bottom: 0;
  right: 0;
  width: 60px;
  height: 60px;
  background-color: #2596be;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border: none;
  z-index: 1;
}  */
/* 
.chat-icon:hover {
  background-color: #1b7892;
} */

.whatsapp-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #25D366;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.whatsapp-btn:hover {
  background-color: #1ebe5d;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chatbot/ChatBot.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU,EAAE,UAAU;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8DAA8D;EAC9D,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;EACxC,6DAA6D;EAC7D,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;;GAGG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".chatbot-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 350px;\n  font-family: \"Roboto\", Arial, sans-serif;\n  z-index: 999;\n}\n\n/* hide chat icon when open */\n.chatbot-container.chat-open .chat-icon {\n  display: none;\n}\n\n.chatbot {\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  background-color: #111827;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  max-height: 500px;\n  overflow: hidden;\n  z-index: 2; /* added */\n}\n\n.chatbot-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #2596be;\n  color: white;\n  padding: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.chatbot-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n  background-color: #111827 !important;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  z-index: 999;\n}\n\n.message {\n  display: inline-block;\n  margin: 5px 0;\n  padding: 10px 15px;\n  border-radius: 16px;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.5;\n  max-width: 80%;\n  word-wrap: break-word;\n}\n\n.message-meta {\n  font-size: 11px;\n  opacity: 0.7;\n  margin-bottom: 4px;\n}\n\n.message.bot {\n  background: linear-gradient(135deg, #0F0F3E 35%, #1A1A01 100%);\n  color: #8d9b9e !important;\n  align-self: flex-start;\n  text-align: left;\n}\n\n.message.user {\n  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);\n  color: white;\n  align-self: flex-end;\n  text-align: right;\n}\n\n.chatbot-footer {\n  display: flex;\n  gap: 8px;\n  padding: 10px;\n  background-color: #111827 !important;\n  border-top: 1px solid #2bb8dd !important;\n}\n\n.chatbot-footer input,\n.chatbot-footer textarea {\n  flex: 1;\n  padding: 12px;\n  border-radius: 16px;\n  border: 1px solid #ddd;\n  font-size: 14px;\n  font-family: \"Roboto\", Arial, sans-serif;\n  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);\n  color: #fff !important;\n  resize: none;\n}\n\n.chatbot-footer button {\n  background-color: #2596be;\n  color: white;\n  border: none;\n  padding: 10px 14px;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.chatbot-footer button:hover {\n  background-color: #1b7892;\n}\n\n.chatbot-recommendations {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 0;\n  align-items: center;\n  animation: fadeIn 0.4s ease;\n}\n\n.recommendation-button {\n  background-color: #2596be;\n  color: white;\n  border: none;\n  border-radius: 32px;\n  width: 80%;\n  align-items: center;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n.chat-fab-container.hidden {\n  opacity: 0;\n  pointer-events: none;\n  transform: scale(0.9);\n}\n\n.chatbot-container {\n  z-index: 100000;\n}\n\n\n.recommendation-button:hover {\n  background-color: #1b7892;\n}\n\n\n/* .chat-icon {\n  position: absolute; \n  bottom: 0;\n  right: 0;\n  width: 60px;\n  height: 60px;\n  background-color: #2596be;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n  cursor: pointer;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border: none;\n  z-index: 1;\n}  */\n/* \n.chat-icon:hover {\n  background-color: #1b7892;\n} */\n\n.whatsapp-btn {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #25D366;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  font-size: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.whatsapp-btn:hover {\n  background-color: #1ebe5d;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
